import { HvSubstation } from "../interfaces/HvSubstation";
import { Asset } from "../interfaces/Asset";
import { HvSubstationMetadata } from "../interfaces/HvSubstationMetadata";
import { Panel } from "../interfaces/SurveyableAsset";

export function convertAssetToHvSubstation(hvSubstationMetadata: Asset | HvSubstationMetadata): HvSubstation {
  return {
    id: hvSubstationMetadata.id,
    customerId: hvSubstationMetadata.customerId,
    locationId: hvSubstationMetadata.locationId,
    name: hvSubstationMetadata.name,
    code: hvSubstationMetadata.serialNumber,
    latitude: hvSubstationMetadata.gpsCoords?.latitude,
    longitude: hvSubstationMetadata.gpsCoords?.longitude,
    company: "company" in hvSubstationMetadata ? hvSubstationMetadata.company : undefined,
    site: "site" in hvSubstationMetadata ? hvSubstationMetadata.site : undefined,
    accessNotes: hvSubstationMetadata.attributes?.find((attribute) => attribute.key === "AccessNotes")?.value || "",
  };
}

export function convertAssetToPanel(asset: Asset): Panel {
  return {
    panelAssetId: asset.id,
    name: asset.name,
    assetTag: asset.assetTag,
    panelNo:
      asset.attributes.find((attribute) => attribute.key === "PanelNo")?.value ||
      asset.attributes.find((attribute) => attribute.key === "ChildAssetNumber")?.value ||
      "",
    assetType: asset.assetTypeKey,
  };
}
